module.exports = __webpack_public_path__ + "fonts/TiemposHeadlineWeb-Black.eot";